import { type ReactNode, createContext, useContext } from 'react';
import type { ReportsSharedTrackingEvent } from '../tracking';

const defaultValue = {
  track: () => console.error('No provider for ReportTrackingContext'),
};

const ReportTrackingContext = createContext<{
  track: (input: ReportsSharedTrackingEvent) => void;
}>(defaultValue);

export const ReportTrackingContextProvider = ({
  children,
  track,
}: {
  children: ReactNode;
  track: (input: ReportsSharedTrackingEvent) => void;
}) => {
  return (
    <ReportTrackingContext.Provider
      value={{
        track,
      }}
    >
      {children}
    </ReportTrackingContext.Provider>
  );
};

export const useReportTracking = () => {
  const context = useContext(ReportTrackingContext);
  if (context === defaultValue) {
    throw new Error('useReportTracking must be used within a ReportTrackingContextProvider');
  }
  return context;
};
